export default __webpack_public_path__ + "static/media/uniqueLogoBlack.e7905418.svg";